import {useEffect, useState} from "react";
import btnScroll from "../../assets/images/home/btn_scroll.png";
import titleBg from "../../assets/images/home/title_bg.png";
import titleBg2x from "../../assets/images/home/title_bg@2x.png";
import titleBtnPlayActive from "../../assets/images/home/title_btn_play_active.png";
import titleBtnPlayDefault from "../../assets/images/home/title_btn_play_default.png";
import titleBtnPreregisterActive from "../../assets/images/commonbtn/title_btn_preregister_active.png";
import titleBtnPreregisterActive2x from "../../assets/images/commonbtn/title_btn_preregister_active@2x.png";
import titleBtnPreregisterDefault from "../../assets/images/commonbtn/title_btn_preregister_defualt.png";
import titleBtnPreregisterDefault2x from "../../assets/images/commonbtn/title_btn_preregister_defualt@2x.png";
import titleBtnTaptapDefault from "../../assets/images/commonbtn/title_btn_taptap_default.png";
import titleBtnTaptapDefault2x from "../../assets/images/commonbtn/title_btn_taptap_default@2x.png";
import titleBtnTaptapHover from "../../assets/images/commonbtn/title_btn_taptap_hover.png";
import titleBtnTaptapHover2x from "../../assets/images/commonbtn/title_btn_taptap_hover@2x.png";

const CDN_BASE_URL = (process.env.REACT_APP_CDN_BASE_URL || process.env.PUBLIC_URL || "").replace(/\/$/, "");
const TAPTAP_PREREGISTER_URL = "https://tap.cn/9tTizkB3";
const TAPTAP_BUTTON_RELEASE_AT = new Date("2026-08-21T11:00:00+08:00").getTime();
const buildMediaUrl = function (path) {
    if (/^https?:\/\//.test(path)) return path;
    if (!CDN_BASE_URL) return path;
    return `${CDN_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};
const HOME_BG_VIDEO_URL = buildMediaUrl(process.env.REACT_APP_HOME_BG_VIDEO_URL || "/videos/home-bg.mp4");

export default function HeroSection({onPlayClick, onPreregisterClick, onBackgroundVideoReady, onBackgroundVideoProgress}) {
    const [isTaptapButtonVisible, setIsTaptapButtonVisible] = useState(function () {
        return Date.now() >= TAPTAP_BUTTON_RELEASE_AT;
    });

    useEffect(() => {
        let timerId = null;
        const stopWatchingReleaseTime = function () {
            if (timerId !== null) {
                window.clearInterval(timerId);
                timerId = null;
            }
            window.removeEventListener("focus", updateTaptapButtonVisibility);
            document.removeEventListener("visibilitychange", updateTaptapButtonVisibility);
        };
        const updateTaptapButtonVisibility = function () {
            if (Date.now() < TAPTAP_BUTTON_RELEASE_AT) return false;
            setIsTaptapButtonVisible(true);
            stopWatchingReleaseTime();
            return true;
        };

        if (!updateTaptapButtonVisibility()) {
            timerId = window.setInterval(updateTaptapButtonVisibility, 1000);
            window.addEventListener("focus", updateTaptapButtonVisibility);
            document.addEventListener("visibilitychange", updateTaptapButtonVisibility);
        }

        return stopWatchingReleaseTime;
    }, []);

    const handleBackgroundVideoProgress = function (event) {
        if (typeof onBackgroundVideoProgress !== "function") return;

        const video = event.currentTarget;
        if (!Number.isFinite(video.duration) || video.duration <= 0 || video.buffered.length === 0) return;

        let bufferedEnd = 0;
        for (let index = 0; index < video.buffered.length; index += 1) {
            bufferedEnd = Math.max(bufferedEnd, video.buffered.end(index));
        }
        onBackgroundVideoProgress((bufferedEnd / video.duration) * 100);
    };

    return (
        <section className="section page1 home-hero" id="home" data-nav="首页">
            <video
                className="home-hero-bg-video"
                src={HOME_BG_VIDEO_URL}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                onLoadedMetadata={handleBackgroundVideoProgress}
                onLoadedData={handleBackgroundVideoProgress}
                onProgress={handleBackgroundVideoProgress}
                onCanPlay={onBackgroundVideoReady}
                onError={onBackgroundVideoReady}
                aria-hidden="true"
            />
            <picture className="home-hero-title-picture">
                <source media="(min-width: 1921px)" srcSet={titleBg2x}/>
                <img className="home-hero-title-bg" src={titleBg} alt="" aria-hidden="true"/>
            </picture>
            <div className="home-hero-title" aria-label="爱是唯一失控的变量">
                <button className="home-title-play-btn" type="button" hidden aria-label="播放视频" onClick={onPlayClick}>
                    <img className="default" src={titleBtnPlayDefault} alt="" aria-hidden="true"/>
                    <img className="active" src={titleBtnPlayActive} alt="" aria-hidden="true"/>
                </button>
                <p className="home-hero-kicker">系统定义幸福的世界里</p>
                <h1 className="home-hero-heading">爱是唯一失控的变量</h1>
            </div>

            <button className="home-title-preregister-btn" type="button" onClick={onPreregisterClick}>
                <picture>
                    <source media="(min-width: 1921px)" srcSet={titleBtnPreregisterDefault2x}/>
                    <img className="default" src={titleBtnPreregisterDefault} alt="" aria-hidden="true"/>
                </picture>
                <picture>
                    <source media="(min-width: 1921px)" srcSet={titleBtnPreregisterActive2x}/>
                    <img className="active" src={titleBtnPreregisterActive} alt="" aria-hidden="true"/>
                </picture>
            </button>

            {isTaptapButtonVisible ? (
                <a
                    className="home-title-preregister-btn home-title-taptap-btn"
                    href={TAPTAP_PREREGISTER_URL}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="前往 TapTap 预约"
                >
                    <picture>
                        <source media="(min-width: 1921px)" srcSet={titleBtnTaptapDefault2x}/>
                        <img className="default" src={titleBtnTaptapDefault} alt="" aria-hidden="true"/>
                    </picture>
                    <picture>
                        <source media="(min-width: 1921px)" srcSet={titleBtnTaptapHover2x}/>
                        <img className="active" src={titleBtnTaptapHover} alt="" aria-hidden="true"/>
                    </picture>
                </a>
            ) : null}

            <div className="home-scroll-btn" aria-hidden="true">
                <img src={btnScroll} alt="" aria-hidden="true"/>
            </div>
        </section>
    );
}
